import PlayerRegistrationStep from './step';
import creators from './actions';
import constants from './constants';

const PROFESSIONAL_AMATEUR_VALUE_PROFESSIONAL = 'Professional';

export default class PlayerRegistrationStep1 extends PlayerRegistrationStep {
    constructor(...args) {
        super(...args);

        this.isExemptionChosen = undefined;
        this.onExemptionChange = this.onExemptionChange.bind(this);
        this.onProfessionalAmateurChange = this.onProfessionalAmateurChange.bind(this);
    }

    static getRequiredRefs() {
        return ['exemption', 'professionalAmateurControl', 'amateurRequiredZone', 'caddieSection', 'caddie'];
    }

    initConcrete() {
        this.initExemption();
        this.initProfessionalAmateur();
        this.addListenersConcrete();
    }

    addListenersConcrete() {
        this.refs.exemption.forEach((radio) => radio.addEventListener('change', this.onExemptionChange));
        this.refs.professionalAmateurControl.forEach((radio) => radio.addEventListener('change', this.onProfessionalAmateurChange));
    }

    initExemption() {
        const selectedExemption = this.refs.exemption.find((radio) => radio.checked);
        if (selectedExemption) {
            this.store.dispatch(creators.changeExemption(selectedExemption.value));
        }
    }

    initProfessionalAmateur() {
        const selectedProfessionalAmateur = this.refs.professionalAmateurControl.find((radio) => radio.checked);
        if (selectedProfessionalAmateur) {
            this.applyProfessionalAmateur(selectedProfessionalAmateur.value);
        }
    }

    onExemptionChange(e) {
        this.applyCaddieVisibility(e.target.value);
        this.store.dispatch(creators.changeExemption(e.target.value));
    }

    onProfessionalAmateurChange(e) {
        this.applyProfessionalAmateur(e.target.value);
    }

    applyCaddieVisibility(exemption) {
        const isDisabled = exemption !== constants.EXEMPTION_YES;
        const display = exemption === constants.EXEMPTION_YES ? 'block' : 'none';

        this.refs.caddieSection.style.display = display;
	this.refs.caddie.forEach((input) => {
            if (isDisabled) {
                input.setAttribute('disabled', 'disabled');
            } else {
                input.removeAttribute('disabled');
            }
        })
    }

    applyStateConcrete({ exemption }) {
        const isExemptionChosen = exemption !== null;
        if (isExemptionChosen !== this.isExemptionChosen) {
            this.applyExemptionChoice(exemption);
        }
    }

    applyExemptionChoice(exemption) {
        this.exemptionValue = exemption;
        this.isExemptionChosen = this.exemptionValue !== null;
        const inputs = [...this.element.querySelectorAll(constants.PARSLEY_INCLUDE_SELECTOR)];

        inputs.forEach((input) => {
            // logic affects every inputs except the exemption radio-group itself
            if (this.refs.exemption.indexOf(input) === -1) {
                if (this.isExemptionChosen) {
                    input.removeAttribute('disabled');
                } else {
                    input.setAttribute('disabled', 'disabled');
                }
            }
        });
    }

    applyProfessionalAmateur(value) {
        if (value === PROFESSIONAL_AMATEUR_VALUE_PROFESSIONAL) {
            this.hideAmateurZone();
        } else {
            this.showAmateurZone();
        }
    }

    hideAmateurZone() {
        this.refs.amateurRequiredZone.style.display = 'none';
    }

    showAmateurZone() {
        this.refs.amateurRequiredZone.style.display = 'block';
    }
}
